import { Text } from '@mantine/core'

interface ValidationErrorProps {
  message: string
}

export function ValidationError({ message }: ValidationErrorProps) {
  return <Text sx={{ fontSize: '10px' }}>{message}</Text>
}
